export default defineNuxtRouteMiddleware(async () => {
  try {
    await useRequestFetch()('/api/schools/registration-access')
  } catch (error: any) {
    const status = error?.statusCode || error?.status
    if (status === 401 || status === 403)
      return navigateTo('/login', { redirectCode: 302 })
    return abortNavigation(
      createError({
        statusCode: 503,
        statusMessage: 'Unable to verify school registration access.',
      }),
    )
  }
})
